/*
  Symbole als SVG. Bewusst keine Emoji: die sehen auf jedem Gerät anders aus
  und lassen sich nicht in der Akzentfarbe einfärben.

  Alle Symbole erben die Textfarbe (`currentColor`) und sind rein schmückend —
  jede Aussage steht zusätzlich als Text daneben. Zustände dürfen niemals nur
  über ein Symbol oder nur über Farbe erkennbar sein.
*/

function Rahmen({ children, groesse = 20 }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ flex: "0 0 auto" }}
    >
      {children}
    </svg>
  );
}

export const Schloss = (p) => (
  <Rahmen {...p}>
    <rect x="4" y="10" width="16" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </Rahmen>
);

export const Haken = (p) => (
  <Rahmen {...p}>
    <path d="M20 6 9 17l-5-5" />
  </Rahmen>
);

export const Kreis = (p) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="8" />
  </Rahmen>
);

export const Punkt = (p) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="6" fill="currentColor" />
  </Rahmen>
);

export const Kreuz = (p) => (
  <Rahmen {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Rahmen>
);

export const Fragezeichen = (p) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.9-.9 1.5v.4" />
    <path d="M12 17h.01" />
  </Rahmen>
);

export const Sprechblase = (p) => (
  <Rahmen {...p}>
    <path d="M20 14a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2Z" />
  </Rahmen>
);

export const Textmarker = (p) => (
  <Rahmen {...p}>
    <path d="M4 20h16" />
    <path d="m8 16 8.5-8.5a2.1 2.1 0 0 1 3 3L11 19H8Z" />
  </Rahmen>
);

export const Dokument = (p) => (
  <Rahmen {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
    <path d="M14 3v5h5" />
  </Rahmen>
);

export const Kalender = (p) => (
  <Rahmen {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M8 3v4M16 3v4M3 11h18" />
  </Rahmen>
);

export const Uhr = (p) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Rahmen>
);

export const PfeilRechts = (p) => (
  <Rahmen {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Rahmen>
);

export const Daumen = (p) => (
  <Rahmen {...p}>
    <path d="M7 21V10l4.5-7A2 2 0 0 1 15 4.6l-.9 4.4H19a2 2 0 0 1 2 2.4l-1.5 7.2a2 2 0 0 1-2 1.4Z" />
    <path d="M7 10H3v11h4" />
  </Rahmen>
);

export const DaumenRunter = (p) => (
  <Rahmen {...p}>
    <path d="M17 3v11l-4.5 7A2 2 0 0 1 9 19.4l.9-4.4H5a2 2 0 0 1-2-2.4l1.5-7.2A2 2 0 0 1 6.5 3Z" />
    <path d="M17 14h4V3h-4" />
  </Rahmen>
);

export const Raster = (p) => (
  <Rahmen {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Rahmen>
);

/*
  Ein Blatt mit Zeilen und Spalten — für die Tabelle.

  Vorher trug sie dasselbe Vierkant-Raster wie die Präsentation. Zwei
  Kacheln nebeneinander mit demselben Zeichen sind keine Auswahl, sondern
  ein Rätsel: Man muss die Beschriftung lesen, um zu erkennen, was man
  anklickt. Die Folie ist eine Fläche mit einem Rahmen, die Tabelle ein
  Gitter — das unterscheidet sich auf einen Blick.
*/
export const Gitter = (p) => (
  <Rahmen {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 9h18M3 14.5h18M9 9v11M15 9v11" />
  </Rahmen>
);

/* Eine Folie: die Fläche, auf der etwas gezeigt wird. */
export const Folie = (p) => (
  <Rahmen {...p}>
    <rect x="2.5" y="4" width="19" height="12.5" rx="2" />
    <path d="M12 16.5V20M8.5 20h7" />
  </Rahmen>
);

export const Ordner = (p) => (
  <Rahmen {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
  </Rahmen>
);

export const Liste = (p) => (
  <Rahmen {...p}>
    <path d="M8 6h13M8 12h13M8 18h13" />
    <path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" />
  </Rahmen>
);

export const Zahnrad = (p) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.7 1.7 0 0 0 8.9 19a1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.6 8.4a1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
  </Rahmen>
);

export const Warnung = (p) => (
  <Rahmen {...p}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9v4M12 17h.01" />
  </Rahmen>
);

export const Waage = (p) => (
  <Rahmen {...p}>
    <path d="M12 4v16M7 20h10" />
    <path d="m5 8 3 5H2ZM19 8l3 5h-6Z" />
    <path d="M5 8h14" />
  </Rahmen>
);

/* Beobachtung: wer die Aufgabe im Blick behält, ohne zuständig zu sein. */
export const Auge = (p) => (
  <Rahmen {...p}>
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z" />
    <circle cx="12" cy="12" r="2.5" />
  </Rahmen>
);

/* Etikett — ein Anhänger mit Loch, wie am Ordner. */
export const Etikett = (p) => (
  <Rahmen {...p}>
    <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9Z" />
    <path d="M7.5 7.5h.01" />
  </Rahmen>
);
